module.exports = __webpack_public_path__ + "img/рз_40.d6a7ba24.png";